import apiClient from '@app/config/axios.config'
import { useQuery, type UseQueryResult } from '@tanstack/react-query'

interface CoverageCount {
  count: number
  fraction: number
}

interface AttributeCoverage {
  null: CoverageCount
  not_null: CoverageCount
  treatment: string
  attribution: {
    [source: string]: CoverageCount
  }
}

export type ElementInfoCoverage = {
  [attribute: string]: AttributeCoverage
}

export interface ElementInfoDetail {
  uid: string
  coverage: ElementInfoCoverage
}

const fetchElementInfoDetail = async (elementLayerId: string): Promise<ElementInfoDetail> => {
  const res = await apiClient.get<ElementInfoDetail>(`/asset/element_info/${elementLayerId}`)
  return res.data
}

/** Attribute coverage/attribution stats for an element layer, sourced from element_info. */
export const useElementInfoDetail = (
  elementLayerId: string | undefined,
): UseQueryResult<ElementInfoDetail> =>
  useQuery({
    queryKey: ['element_info', elementLayerId],
    queryFn: () => fetchElementInfoDetail(elementLayerId as string),
    enabled: !!elementLayerId,
  })
